/**
 * Layout mobile: BottomNav h-[4.25rem].
 */

/** `bottom` do StickyPageAction — acima da BottomNav com folga. */
export const MOBILE_STICKY_BOTTOM_CLASS = 'bottom-20';

/** Padding extra no conteúdo quando há barra sticky. */
export const MOBILE_PAGE_PADDING_WITH_STICKY_CLASS = 'pb-28 md:pb-0';

/** Padding mínimo do main em mobile (BottomNav). */
export const MOBILE_MAIN_PADDING_CLASS = 'pb-20 md:pb-0';

/** Oculta título/subtítulo da página em mobile — já aparece no MobileTopBar. */
export const DESKTOP_PAGE_HEADER_CLASS = 'hidden md:flex';
export const DESKTOP_PAGE_TITLE_CLASS = 'hidden md:block';
